<template>
  <div class="form-rich-text form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        ref="formRichText"
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
      >
        <quill-editor
          class="quill-editor-readOnly"
          v-if="renderSence === 'read'"
          :content="formValue"
          :disabled="true"
          :options="{
            readOnly: true,
            placeholder: '-',
            modules: {
              toolbar: []
            }
          }"
        ></quill-editor>
        <quill-editor
          v-else
          ref="quillEditor"
          :content="formValue"
          :disabled="widget.readOnly"
          :class="{'quill-readOnly': widget.readOnly}"
          :options="{
            placeholder: widget.readOnly ? '' : widget.placeholder,
            modules: {
              toolbar: {
                container: widget.readOnly ? [] : toolbarOptios,
                handlers: {
                  'image': handleImageClick
                }
              }
            }
          }"
          @change="onChange($event)"
        ></quill-editor>
        <input 
          ref="inputImage" 
          type="file" 
          :accept="accept.toString()" 
          @change="handleChange" 
          multiple
          style="display:none;" 
        />
      </x-proxy-form-item>
    </div>
  </div>
</template>
<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'FormRichText',
  mixins: [FormWidgetConfigMixin],
  components: {
    quillEditor
  },
  data() {
    return {
      accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
      toolbarOptios: [
        [{ 'header': [1, 2, 3, 4, 5, false] }], // 标题
        ["bold"], // 粗体
        // [{ 'font': [] }], // 字体
        ["italic"], // 斜体
        ["underline"], // 下划线
        ["strike"], // 删除线
        [{ 'color': [] }, { 'background': [] }], // 文字颜色 背景颜色
        // ["link"], // 插入链接
        [{ 'list': 'ordered'}, { 'list': 'bullet' }], // 列表
        // [{ 'align': [] }], // 对齐方式
        // ["blockquote"], // 引用
        // ["clear"], // 撤销
        ['image']
      ]
    }
  },
  created() {
    const unWatch = this.$watch('formValue', (newVal, oldVal) => {
      // 修复编辑时，富文本自动聚焦的问题
      if (newVal && typeof oldVal === 'undefined') {
        this.$refs.quillEditor.quill.enable(false)
        setTimeout(() => {
          this.$refs.quillEditor.quill.enable(!this.widget.readOnly)
          if (unWatch) unWatch()
        }, 0)
      }
    }, {
      immediate: true
    })
  },
  methods: {
    onChange(event) {
      this.formValue = event.html
    },
    handleImageClick() {
      this.$refs.inputImage && this.$refs.inputImage.click()
    },
    handleChange(event) {
      const fileList = Array.from(event.target.files)
      fileList.forEach(file => {
        this.widget.customUploadImg(file).then(url => {
          let quill = this.$refs.quillEditor.quill
          let length = quill.getSelection().index//光标位置
          // 插入图片  图片地址
          quill.insertEmbed(length, 'image', url)
          // 调整光标到最后
          quill.setSelection(length + 1)//光标后移一位
        })
      })
      this.$refs.inputImage.value = ''
    }
  }
}
</script>

<style lang="scss">
.form-rich-text {
  .quill-editor {
    .ql-formats {
      margin: 0;
    }
    .ql-snow.ql-toolbar button, .ql-snow .ql-toolbar button {
      width: 1.71rem;
    }
    .ql-expanded {
      z-index: 10;
    }
    .ql-picker-options {
      background-color: $--app-box-bgColor;
    }
    .ql-editor.ql-blank::before {
      font-style: normal;
      left: 0;
      color: $--app-notice-font-color;
    }
    .ql-container {
      // min-height: 7rem;
      max-height: 23rem;
      overflow-x: hidden;
      overflow-y: auto;
      max-width: calc(100vw - 3.42rem);
    }
    .ql-toolbar.ql-snow {
      padding: 0;
      margin: 0 -0.571429rem;
    }
    .ql-toolbar.ql-snow, .ql-container.ql-snow {
      border: 0;
    }
    .ql-editor {
      padding: 0.857143rem 0;
    }
    &.quill-readOnly {
      .ql-toolbar.ql-snow {
        display: none;
      }
      .ql-editor {
        padding: 0;
      }
    }
  }
  .quill-editor-readOnly {
    .ql-toolbar.ql-snow {
      display: none;
    }
    .quill-editor {
      padding: 0;
    }
    .quill-editor {
      border: 0;
    }
  }
}
</style>
